var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup1000003612(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9226_4064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.39565 1.72656H28.5857C34.7347 1.72656 36.272 3.26384 36.272 9.39565V20.3293C36.272 26.4784 34.7347 27.9984 28.6029 27.9984H9.39565C3.26384 28.0157 1.72656 26.4784 1.72656 20.3466V9.39565C1.72656 3.26384 3.26384 1.72656 9.39565 1.72656Z",
    stroke: "#1DBF73",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 28.0156V36.272",
    stroke: "#1DBF73",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.72656 20.7266H36.272",
    stroke: "#1DBF73",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2266 36.2734H26.772",
    stroke: "#1DBF73",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5012 8.10369L15.9595 14.6202C15.7046 15.0892 15.9058 15.662 16.4088 15.8996C16.5568 15.9695 16.7144 16.0026 16.8696 16.0026C17.2421 16.0026 17.6013 15.8118 17.7812 15.4806L21.3229 8.9641C21.5778 8.49516 21.3766 7.92237 20.8736 7.68481C20.3707 7.44719 19.7561 7.6347 19.5012 8.10369Z",
    fill: "#1DBF73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0186 9.95349C22.4174 9.58174 23.064 9.58174 23.4627 9.95349L25.7035 12.0424C26.1023 12.4142 26.1023 13.0169 25.7035 13.3886L23.4627 15.4775C23.2633 15.6634 23.002 15.7563 22.7407 15.7563C22.4793 15.7563 22.218 15.6634 22.0186 15.4775C21.6199 15.1058 21.6199 14.503 22.0186 14.1313L23.5374 12.7155L22.0186 11.2997C21.6199 10.9279 21.6199 10.3252 22.0186 9.95349Z",
    fill: "#1DBF73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8011 10.3767L15.3199 11.7926C15.7187 12.1643 15.7187 12.767 15.3199 13.1387C15.1205 13.3246 14.8592 13.4176 14.5979 13.4176C14.3365 13.4176 14.0752 13.3246 13.8758 13.1387L11.635 11.0498C11.2362 10.6781 11.2362 10.0754 11.635 9.70367L13.8758 7.61475C14.2746 7.243 14.9212 7.243 15.3199 7.61475C15.7187 7.98649 15.7187 8.5892 15.3199 8.96089L13.8011 10.3767Z",
    fill: "#1DBF73"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9226_4064"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000003612);
export default __webpack_public_path__ + "static/media/Group 1000003612.30df305886e38df60afb9a8c9e990cc0.svg";
export { ForwardRef as ReactComponent };